// extracted by mini-css-extract-plugin
export default {"V2FormRadio":"V2FormRadio--m4D61","markerAnimationScale":"markerAnimationScale--T1STs"};